const Forms = {
    init() {
        this.polyfillAppend();
        this.polyfillPrepend();

        this.initContactFormBuraliste();
        console.log('init forms');
        document.querySelectorAll('.wpcf7').forEach($container => {
            this.initForm($container);
        });

        document.addEventListener( 'wpcf7submit', function( event ) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, false );
        // document.querySelectorAll('.wpcf7').forEach(this.initForm);

        this.initNextButton();
    },

    initNextButton () {
        // cf7mls_next cf7mls_btn action-button btn btn-secondary
        const $nextButtons = document.querySelectorAll('.cf7mls_next.cf7mls_btn.action-button');
        $nextButtons.forEach($nextButton => {
            $nextButton.classList.add('btn', 'btn-secondary');
            const span = document.createElement("span");
            const texte = $nextButton.innerHTML;
            $nextButton.innerHTML = "";
            span.innerHTML = texte;
            $nextButton.appendChild(span);
        });
    },

    initForm($container) {
        const $form = $container.querySelector('.wpcf7-form');
        const $alert = $container.querySelector('.screen-reader-response');

        // console.log('container:', $container);
        this.changeFormAnchor($container);

        if ($alert) {
            const $clonedAlert = $alert.cloneNode();
            $clonedAlert.innerHTML = $alert.innerHTML;

            $alert.parentNode.removeChild($alert);
            $form.prepend($clonedAlert);
        }

        $form.querySelectorAll('input, textarea, select').forEach($el => {
            const type = $el.getAttribute('type');
            if ($el.classList.contains('wpcf7-select')) {
                // Add arrow down
                const xmlns = 'http://www.w3.org/2000/svg';
                const $selectArrowSVG = document.createElementNS(xmlns, 'svg');
                $selectArrowSVG.setAttributeNS(null, 'viewBox', '0 0 12 8');
                const $selectArrowSVGGroup = document.createElementNS(xmlns, 'g');
                $selectArrowSVGGroup.setAttributeNS(null, 'stroke-width', '2');
                $selectArrowSVGGroup.setAttributeNS(null, 'stroke-linecap', 'round');
                $selectArrowSVGGroup.setAttributeNS(null, 'fill', 'none');
                const $selectArrowSVGPath = document.createElementNS(xmlns, 'path');
                $selectArrowSVGPath.setAttributeNS(null, 'd', 'M302 5L307 10 312 5');
                $selectArrowSVGPath.setAttributeNS(null, 'transform', 'translate(-1262 -284) translate(163 186) translate(436 15) translate(362 79)');
                $selectArrowSVG.appendChild($selectArrowSVGGroup);
                $selectArrowSVGGroup.appendChild($selectArrowSVGPath);
                $el.parentNode.appendChild($selectArrowSVG);

                const $oldLabel = $el.parentNode.parentNode.querySelector('label');
                if ($oldLabel) {
                    const $label = document.createElement('label');
                    $label.innerText = $oldLabel.innerText;
                    const $oldLabelNextElement = $oldLabel.nextElementSibling;
                    if ($oldLabelNextElement.tagName === 'BR') {
                        $oldLabelNextElement.parentNode.removeChild($oldLabelNextElement);
                    }
                    $oldLabel.parentNode.removeChild($oldLabel);
                    $el.parentElement.classList.add('wpcf7-material');
                    $el.parentNode.append($label);

                    const $nextElementSibling = $el.nextElementSibling;
                    if ($nextElementSibling) {
                        const $nextElementSiblingCloned = $nextElementSibling.cloneNode();
                        $nextElementSibling.parentNode.removeChild($nextElementSibling);
                        $el.parentNode.append($nextElementSibling);
                    }

                    const $firstOption = $el.querySelector('option:first-child');
                    if ($firstOption.value === '') {
                        $firstOption.innerText = '';
                    } else {
                        const $option = document.createElement('option');
                        $el.prepend($option);
                        $el.value = '';
                    }

                    const onChange = () => {
                        if ($el.value !== '') {
                            $el.classList.add('has-content');
                        } else {
                            $el.classList.remove('has-content');
                        }
                    };
                    onChange();
                    $el.addEventListener('change', onChange);
                }
            } else if ($el.tagName === 'TEXTAREA' || (type !== 'hidden' && (type === 'text' || type === 'email' || type === 'tel' || type === 'url'))) {
                const $label = document.createElement('label');
                $label.innerText = $el.placeholder;

                $el.placeholder = '';

                $el.parentElement.classList.add('wpcf7-material');
                $el.parentElement.append($label);

                const $nextElementSibling = $el.nextElementSibling;
                if ($nextElementSibling) {
                    const $nextElementSiblingCloned = $nextElementSibling.cloneNode();
                    $nextElementSibling.parentNode.removeChild($nextElementSibling);
                    $el.parentNode.append($nextElementSibling);
                }

                const onKeyUp = () => {
                    if ($el.value !== '') {
                        $el.classList.add('has-content');
                    } else {
                        $el.classList.remove('has-content');
                    }
                };
                onKeyUp();
                $el.addEventListener('keyup', onKeyUp);
            }
        });
    },

    initContactFormBuraliste() {
        function add_class_from_element(el, addClass){
            if ( !el.classList.contains(addClass) ) {
                el.classList.add(addClass);
            }
        }

        function remove_class_from_element(el, removeCLass){
            if (el.classList.contains(removeCLass)) {
                el.classList.remove(removeCLass);
            }
        }

        function custom_toggle_hide(id, key, key_input) {
            var function_value = document.getElementById(key_input);
            if (!function_value) {
                return;
            }
            if( function_value.value === key ){
                document.getElementById(id).style.display = "block";
            }
            function_value.addEventListener('change', function() {
                if( function_value.value === key ){
                    document.getElementById(id).style.display = "block";
                }else {
                    document.getElementById(id).style.display = "none";
                }
            });
        }

        function custom_toggle_boolean_hide(id, key, key_input, default_value, true_or_false) {
            var rad = document.getElementsByName(key_input);
            let ret = null;
            let indice = true_or_false ? 0 : 1;
            if( rad.length!=0 && rad[indice].checked ){
                document.getElementById(id).style.display = default_value;
            }

            for (var i = 0; i < rad.length; i++) {
                rad[i].addEventListener('change', function() {

                    ret = this.value;
                    if(ret != null && ret == key){
                        document.getElementById(id).style.display = "block";
                    } else {
                        document.getElementById(id).style.display = "none";
                    }
                });
            }
        }

        /**
         * Hide textarea field 'precision'
         */
        if( document.getElementById("contact-form-buraliste") !== null ){
            custom_toggle_boolean_hide("precision", "Non", "radio", "none", false);
        }

        /**
         * Hide fields 'localisation'
         */
        if( document.getElementById("contact-form") !== null ){
            //Handle fields
            custom_toggle_hide("localisation", "Mairie & Collectivité", "your_function");
            custom_toggle_hide("e-commercant", "E-commerçant", "your_function");
            custom_toggle_hide("banquier", "Banque", "your_function");
            custom_toggle_hide("facturier", "Facturier", "your_function");

            //Handle radio toggle
            custom_toggle_boolean_hide("precision-cms", "Oui", "radio-cms", "block", true);
        }


    },

    polyfillAppend(){
        // Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
        (function (arr) {
            arr.forEach(function (item) {
                if (item.hasOwnProperty('append')) {
                    return;
                }
                Object.defineProperty(item, 'append', {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: function append() {
                    var argArr = Array.prototype.slice.call(arguments),
                        docFrag = document.createDocumentFragment();

                    argArr.forEach(function (argItem) {
                        var isNode = argItem instanceof Node;
                        docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                    });

                    this.appendChild(docFrag);
                    }
                });
            });
        })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
    },

    polyfillPrepend(){
        // Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
        (function (arr) {
            arr.forEach(function (item) {
                if (item.hasOwnProperty('prepend')) {
                    return;
                }
                Object.defineProperty(item, 'prepend', {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: function prepend() {
                    var argArr = Array.prototype.slice.call(arguments),
                        docFrag = document.createDocumentFragment();

                    argArr.forEach(function (argItem) {
                        var isNode = argItem instanceof Node;
                        docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                    });

                    this.insertBefore(docFrag, this.firstChild);
                    }
                });
            });
        })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
    },

    changeFormAnchor ($container) {
        // console.log('form: ', $container);
        const $containerParent = $container.parentNode;
        const $anchor = document.createElement('div');
        const $form = $container.querySelector('form');
        const url_anchor = $form.getAttribute('action');
        const url_array = url_anchor.split('#');
        $form.setAttribute('action', url_array[0] + '#page-form');
        $anchor.setAttribute('id', 'page-form');
        $anchor.classList.add('form-anchor');
        $containerParent.insertBefore($anchor, $container);
    }

}

export default Forms;